export default "__VITE_ASSET__5bd0e8b0__"